import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.network.dashboard');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-network-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.network.dashboard/view.scss */
/* src/app/portal.network.dashboard/view.scss: no such file or directory */`],
})
export class PortalNetworkDashboardComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    constructor(@Inject( Service)         public service: Service,    ) { }


    public async ngOnInit() {
    }
}

export default PortalNetworkDashboardComponent;